// extracted by mini-css-extract-plugin
export default {"parent":"Backup_parent__Buqsj","button":"Backup_button__PGX6q"};